export default __webpack_public_path__ + "images/f128065e6fc49b7fbce412af11a664da.svg";